module.exports = __webpack_public_path__ + "static/media/instagram-social-media-svgrepo-com.a1eecd0d.svg";